export default __webpack_public_path__ + "static/media/header-logo.03074767.svg";